export enum ApplicationRoutesEnum {
  Setup = 'setup',
  Edit = 'edit',
  Members = 'members',
  Tasks = 'tasks',
  LinkNew = 'link/new',
}
